import {Component, Injector} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import { ActivatedRoute } from '@angular/router';
import {UserFormService} from '../services/user-form.service';
import {AuthService} from '@services/auth.service';
import {EventsService} from '@services/events.service';

@Component({
    providers: [
    ],
    selector: 'user-profile',
    templateUrl: './user-profile.component.html',
})
export class UserProfileComponent extends FrontendFormComponent {
    public email: string;
    public active = true;

    public afterSaveMessage = 'Данные успешно сохранены';

    constructor(
        injector: Injector,
        public formService: UserFormService,
        private route: ActivatedRoute,
        private events: EventsService,
        private authService: AuthService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            active: [],
            last_name: [],
            first_name: [],
            email: [],
            password: [],
            new_password: []
        });

        const {formValues} = this.route.snapshot.data;

        if (formValues) {
            this.setFormValues(formValues, this.form);
        }

        this.email = this.form.get('email').value;
        this.active = this.form.get('active').value;
    }

    afterSave(): any {
        super.afterSave();
        this.resetPasswordFields();
        this.authService.updateUserInfo().toPromise();

        this.email = this.form.get('email').value;
        this.active = this.form.get('active').value;
    }

    private resetPasswordFields() {
        this.form.get('password').patchValue(null);
        this.form.get('new_password').patchValue(null);
    }
}
